import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="nanoteh-tasks" bigPaddings={true} isMargin={false}>
                <CommonTitle>Задачи</CommonTitle>
                <div className="nanoteh-tasks__wrapper">
                    <ul className="case__ol-list nanoteh-tasks__item-first">
                        <div className="nanoteh-tasks__item-img">
                            <img
                                src="/images/svg/nanotech/nanotech-tasks__item-img1.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <li className="common__ol-item" key={'index'}>
                            <span className="common__ol-number" style={{ color: '#3498dc' }}>
                                1.
                            </span>
                            <span className="common__ol-info">
                                Вывести более 1&nbsp;000 фраз из&nbsp;семантического ядра
                                в&nbsp;ТОП-10 на&nbsp;территории 11&nbsp;городов-миллионников
                                в&nbsp;течение 6&nbsp;месяцев в&nbsp;поисковых системах Яндекс
                                и&nbsp;Google.
                            </span>
                        </li>
                    </ul>

                    <ul className="case__ol-list nanoteh-tasks__item-second">
                        <div className="nanoteh-tasks__item-img">
                            <img
                                src="/images/svg/nanotech/nanotech-tasks__item-img2.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <li className="common__ol-item" key={'index'}>
                            <span className="common__ol-number" style={{ color: '#3498dc' }}>
                                2.
                            </span>
                            <span className="common__ol-info">
                                Увеличить количество посещений сайта www.membranium.com минимум
                                на&nbsp;30%.
                            </span>
                        </li>
                    </ul>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
